import React from 'react';

const AdminsTable = ({ admins, isSuperAdmin, isDirector, openEdit, handleDelete }) => (
  <div className="admins-table-scroll">
    <table className="admins-table students-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Mobile</th>
          <th>Role</th>
          <th>Added By</th>
          <th>Updated By</th>
          <th>Created Date</th>
          <th>Updated Date</th>
          <th className="actions-header">Actions</th>
        </tr>
      </thead>
      <tbody>
        {admins.map(a => (
          <tr key={a._id}>
            <td>{a.name}</td>
            <td>{a.email}</td>
            <td>{a.mobile || 'N/A'}</td>
            <td>{a.role}</td>
            <td>{a.createdBy ? a.createdBy.name : 'N/A'}</td>
            <td>{a.updatedBy ? a.updatedBy.name : 'N/A'}</td>
            <td>{a.createdAt ? new Date(a.createdAt).toLocaleString() : 'N/A'}</td>
            <td>{a.updatedAt ? new Date(a.updatedAt).toLocaleString() : 'N/A'}</td>
            <td>
              <div className="admin-actions">
                {(isSuperAdmin || isDirector) ? (
                  <>
                    <button className="edit-btn" onClick={() => openEdit(a)}>Edit</button>
                    <button className="delete-btn" onClick={() => handleDelete(a._id)}>Delete</button>
                  </>
                ) : (
                  <>
                    <button className="edit-btn" disabled>Edit</button>
                    <button className="delete-btn" disabled>Delete</button>
                  </>
                )}
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export default AdminsTable; 